import styled from 'styled-components'
import { themeGet } from 'styled-system'
import GradeProgressData from 'components/GradeProgressData'

const splitTwoColumnGrid = gradeCount => {
  const rows = Math.max(1, Math.ceil(gradeCount / 2))
  return `
    grid-auto-flow: column;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(${rows}, minmax(50px, auto));
    max-height: none;
  `
}

export const GradeListWrapper = styled.div.attrs(({ splitTwoColumns }) => ({
  'data-layout': splitTwoColumns ? 'two-column-split' : 'default',
  'data-testid': 'grade-list-wrapper',
}))`
  display: grid;
  gap: 1.375rem 1.75rem;

  ${({ splitTwoColumns, gradeCount, bhuStatus }) =>
    splitTwoColumns && gradeCount > 0
      ? splitTwoColumnGrid(gradeCount)
      : `
    ${
      bhuStatus
        ? `grid-template-rows: repeat(2, minmax(50px, 1fr));`
        : `grid-template-rows: repeat(auto-fill, minmax(50px, 1fr));`
    }
    grid-template-columns: repeat(auto-fill, minmax(40%, 1fr));
  `}

  ${themeGet('breakpoints.belowTablet')} {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: unset;
    padding-bottom: 1.125rem;
  }

  ${themeGet('breakpoints.mobileLarge')} {
    gap: 0.875rem;
  }
`

export const StyledGradeProgressData = styled(GradeProgressData)`
  [class*='Background'] {
    max-width: unset;
  }

  ${themeGet('breakpoints.belowTablet')} {
    padding-bottom: 1.4375rem;
  }

  ${themeGet('breakpoints.mobile')} {
    padding-bottom: 1.5625rem;
  }
`
